import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_API_URL } from '@cnt-workspace/data-access';
import { ICaretaker, ICaretakerResponse, ICaretakerWhere, ICountResponse } from '@curbnturf/entities';
import { objectToUrlParams } from '@curbnturf/helpers';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'caretaker';

/** Caretaker change requests/submissions for boondocks and POIs. Moved from the app's services/caretaker.service.ts. */
@Injectable({ providedIn: 'root' })
export class AdminCaretakerApiService {
  private readonly http = inject(HttpClient);

  list(query: ICaretakerWhere = {}): Observable<ICaretakerResponse> {
    return this.http.get<ICaretakerResponse>(`${API_URL}?${objectToUrlParams(query, true)}`);
  }

  /** Marks a list row's submissions handled, or open again with `handled` false. */
  setHandled(row: ICaretaker, handled: boolean): Observable<unknown> {
    const path = row.boondockId ? `boondock/${row.boondockId}` : `poi/${row.poiId}`;
    return this.http.patch(`${API_URL}/${path}/handled`, { syncIds: row.syncIds ?? [], handled });
  }

  /** How many open submissions the list shows (the Home and menu count). */
  count(): Observable<ICountResponse> {
    return this.http.get<ICountResponse>(`${API_URL}/count`);
  }
}
